import { STORE_PENDING_TYPE, STORE_STATUS, STORE_TYPE, STORE_TYPE_OPTIONS } from "../../../commons/constants/store";
import styles from "./store-card.module.scss";
import { useState } from "react";
import defaultAxios from "../../../commons/utils/axios";
import { CHANGE_STORE_STATUS_URL } from "../../../commons/constants/api-urls";
import { Tooltip, message } from "antd";
import PopupStatus from "./PopupStatus";
import StatusStore from "./StatusStore";
import PopupStatusMember from "./PopupStatusMember";
import TypeStore from "./TypeStore";
import ImageDisplay from "../../../commons/components/ImageDisplay";
import { CustomStatus } from "../../../commons/components/CustomStatus/CustomStatus";
interface StoreCardProps extends React.HTMLAttributes<HTMLDivElement> {
  storeName: string;
  image: string;
  storeId?: string;
  className?: string;
  status?: STORE_STATUS;
  refresh?: () => void;
  storeIdManageByMember?: string;
  isAutoThresholdEnabled?: boolean;
  isTerminalEnabled?: boolean;
  type?: STORE_PENDING_TYPE;
  reasonReject?: string;
  storeType: STORE_TYPE;
}
const StoreCard: React.FC<StoreCardProps> = ({
  storeName,
  image,
  className,
  status,
  storeId,
  refresh,
  storeIdManageByMember,
  isAutoThresholdEnabled,
  isTerminalEnabled,
  type,
  reasonReject,
  storeType,
  ...props
}: StoreCardProps) => {
  const [openPopup, setOpenPopup] = useState(false);
  const storeTypeLabel = storeType ? STORE_TYPE_OPTIONS.find(item => item.value === storeType)?.label : "";

  function handleOpenModal() {
    setOpenPopup(!openPopup);
  }

  async function handleOpenStore(storeId: string) {
    try {
      await defaultAxios.patch(CHANGE_STORE_STATUS_URL(storeId), { status: STORE_STATUS.LIVE });
      message.success("Open store successfully");
      refresh && refresh();
    } catch (error) {
      console.log(error);
      message.error("Close store failed");
    }
  }
  async function handleCloseStore(storeId: string) {
    try {
      await defaultAxios.patch(CHANGE_STORE_STATUS_URL(storeId), { status: STORE_STATUS.CLOSED });
      message.success("Close store successfully");
      refresh && refresh();
    } catch (error) {
      console.log(error);
      message.error("Close store failed");
    }
  }

  async function handleOffStore(storeId: string) {
    try {
      await defaultAxios.patch(CHANGE_STORE_STATUS_URL(storeId), { status: STORE_STATUS.OFFLINE });
      message.success("Offline store successfully");
      refresh && refresh();
    } catch (error) {
      console.log(error);
      message.error("Close store failed");
    }
  }

  async function handleToggleThreshold(storeId: string, auto: boolean) {
    try {
      await defaultAxios.patch(CHANGE_STORE_STATUS_URL(storeId), { isAutoThresholdEnabled: auto });
      message.success("Toggle successfully");
      refresh && refresh();
    } catch (error) {
      console.log(error);
      message.error("Toggle failed");
    }
  }

  async function handleToggleTerminal(storeId: string, auto: boolean) {
    try {
      await defaultAxios.patch(CHANGE_STORE_STATUS_URL(storeId), { isTerminalEnabled: auto });
      message.success("Toggle successfully");
      refresh && refresh();
    } catch (error) {
      console.log(error);
      message.error("Toggle failed");
    }
  }

  return (
    <Tooltip title={reasonReject && `Reason : ${reasonReject}`} placement="bottom">
      <div
        className={[styles.wrapper, className].join(" ")}
        {...props}
        onMouseLeave={() => {
          setOpenPopup(false);
        }}
      >
        {/* <img alt="store" /> */}
        <div className={styles.imageWrapper}>
          <ImageDisplay src={image} />
          <div className={styles.storeCardBackDrop}></div>
          <CustomStatus className={styles.storeTypeStatus} label={storeTypeLabel || ""} />
        </div>

        <div className={styles.nameWrapper}>
          <span className={styles.name}>{storeName}</span>
        </div>

        {type?.toString() && <TypeStore type={type} />}

        {status?.toString() && storeId && (
          <>
            <StatusStore status={status} storeId={storeId} handleOpenModal={handleOpenModal} />
            {storeIdManageByMember ? (
              <>
                {openPopup && status !== STORE_STATUS.DRAFT && (
                  <PopupStatusMember
                    status={status}
                    storeId={storeId}
                    handleCloseStore={handleCloseStore}
                    handleOffStore={handleOffStore}
                    handleOpenStore={handleOpenStore}
                    handleToggleThreshold={handleToggleThreshold}
                    isAutoThresholdEnabled={isAutoThresholdEnabled}
                    isTerminalEnabled={isTerminalEnabled}
                  />
                )}
              </>
            ) : (
              <>
                {openPopup && status !== STORE_STATUS.DRAFT && (
                  <PopupStatus
                    status={status}
                    storeId={storeId}
                    handleCloseStore={handleCloseStore}
                    handleOffStore={handleOffStore}
                    handleOpenStore={handleOpenStore}
                    handleToggleThreshold={handleToggleThreshold}
                    handleToggleTerminal={handleToggleTerminal}
                    isAutoThresholdEnabled={isAutoThresholdEnabled}
                    isTerminalEnabled={isTerminalEnabled}
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
    </Tooltip>
  );
};

export default StoreCard;
